// extracted by mini-css-extract-plugin
module.exports = {"grid":"substitution-grid_grid__X9SKy"};